/* RESPONSIBLE TEAM: team-reporting */
import { isValidEmail } from 'embercom/lib/email';

export interface EmailValidationResult {
  validEmails: string[];
  invalidParts: string[];
}

export function parseEmailInputParts(input: string): string[] {
  let EMAIL_SEPARATORS = [',', '|', ';', ' ', '\n', '\t'];
  let EMAIL_SPLIT_REGEX = new RegExp(`[${EMAIL_SEPARATORS.join('\\\\')}]+`);

  return input
    .trim()
    .split(EMAIL_SPLIT_REGEX)
    .map((email) => email.trim())
    .map((email) => {
      if (email[0] === '<' && email[email.length - 1] === '>') {
        return email.slice(1, email.length - 1);
      }
      return email;
    })
    .filter((email) => email !== '');
}

/**
 * Validates email string and separates valid emails from invalid parts.
 */
export function validateAndSeparateEmails(input: string): EmailValidationResult {
  let inputParts = parseEmailInputParts(input);
  let validEmails: string[] = [];
  let invalidParts: string[] = [];

  inputParts.forEach((part) => {
    if (isValidEmail(part)) {
      validEmails.push(part);
    } else {
      invalidParts.push(part);
    }
  });

  return { validEmails, invalidParts };
}
